import Modal from "Components/shared/modal";
import Text from "Components/shared/text";
import React from "react";


class AppErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false, openModal: false };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true, openModal: true };
    }
  
    componentDidCatch(error, errorInfo) {
      // You can also log the error to an error reporting service
      // Maybe call an external logging service or endpoint here
      
    }
    handleClose = () => {
        this.setState({ openModal: false });
        window.location.reload();
       
    };
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return (
            <Modal header="An Error Page" onClose={this.handleClose.bind(this)} open={this.openModal} unmountOnExit disableBackdropClick>
                <Text variant="lg">Ooops... An Error Occurred while loading this page.</Text>
                <Text>Check network and relaod the page.</Text>
            </Modal>
        );
      }
  
      return this.props.children; 
    }
  }

  export default AppErrorBoundary;